"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const withTheme_1 = require("@material-ui/core/styles/withTheme");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const AppSpinner_1 = require("../app-spinner/AppSpinner");
const InformationDialog_1 = require("../dialog/InformationDialog");
const InteractiveGameStyle_1 = require("../earn/jss/InteractiveGameStyle");
const LoadError_1 = require("../load-error/LoadError");
const INITIAL_STATE = {
    loading: false,
    gameCompleted: false,
    gameType: 'prize',
    isPortrait: false
};
class DigitalRevealGame extends React.Component {
    constructor(props) {
        super(props);
        this.orientationChange = () => {
            this.setState({ isPortrait: true });
        };
        this.onCloseGame = () => {
            if (!!this.props.onGameCloseHandler) {
                this.props.onGameCloseHandler();
            }
        };
        this.registerGame = (vendor) => {
            if (vendor === 'SGI') {
                window.addEventListener('message', this.receiveSGIMessage, false);
            }
            else {
                window.addEventListener('message', this.receiveMessage, false);
            }
        };
        this.unRegisterGame = (vendor) => {
            if (vendor === 'SGI') {
                window.removeEventListener('message', this.receiveSGIMessage);
            }
            else {
                window.removeEventListener('message', this.receiveMessage);
            }
        };
        this.receiveSGIMessage = async (event) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            try {
                switch (event.data.type) {
                    case 'end': {
                        await ((_b = (_a = this.props).onGameEndHandler) === null || _b === void 0 ? void 0 : _b.call(_a));
                        this.setState({ gameCompleted: true });
                        return console.warn('***** onGameEndHandler');
                    }
                    case 'enterTicket': {
                        await ((_d = (_c = this.props).onGameExitHandler) === null || _d === void 0 ? void 0 : _d.call(_c));
                        return console.warn('***** onGameExitHandler');
                    }
                    case 'gameReady': {
                        (_f = (_e = this.props).onGameReadyHandler) === null || _f === void 0 ? void 0 : _f.call(_e);
                        return console.warn('***** onGameReadyHandler');
                    }
                    case 'start': {
                        (_h = (_g = this.props).onGameStartHandler) === null || _h === void 0 ? void 0 : _h.call(_g);
                        return console.warn('***** onGameStartHandler');
                    }
                    default:
                        return;
                }
            }
            catch (_j) { }
        };
        this.receiveMessage = async (event) => {
            try {
                const data = JSON.parse(event.data);
                if (!data || data.type !== 'poGame')
                    return;
                const gameData = {
                    points: this.props.gamePoints,
                    message: this.props.gameMessage ? this.props.gameMessage : '',
                    type: 'prize',
                    multiplier: this.props.multiplier,
                    ticketPrice: this.props.ticketPrice,
                    entries: this.props.gameEntries,
                    gameFace: this.props.gameFace,
                    gameConfig: this.props.gameConfig,
                    hideExitButtons: true,
                    drawNumber: this.props.drawNumber
                };
                switch (data.name) {
                    case 'onGamePauseHandler': {
                        if (this.props.onGamePauseHandler)
                            this.props.onGamePauseHandler();
                        return console.warn('***** onGamePauseHandler');
                    }
                    case 'onGameResumeHandler': {
                        if (this.props.onGameResumeHandler)
                            this.props.onGameResumeHandler();
                        return console.warn('***** onGameResumeHandler');
                    }
                    case 'onGameResultHandler': {
                        if (this.props.onGameResultHandler)
                            this.props.onGameResultHandler(data.data);
                        return console.warn('***** onGameResultHandler ', data.data);
                    }
                    case 'onGameReplayHandler': {
                        this.setState({ loading: true });
                        if (this.props.onGameReplayHandler)
                            await this.props.onGameReplayHandler();
                        this.setState({ loading: false });
                        document.getElementById('iframe').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: gameData
                        }), '*');
                        return console.warn('***** onGameReplayHandler');
                    }
                    case 'onGameStartHandler': {
                        if (this.props.onGameStartHandler)
                            this.props.onGameStartHandler();
                        return console.warn('***** onGameStartHandler');
                    }
                    case 'onGameReadyHandler': {
                        if (this.props.onGameReadyHandler)
                            this.props.onGameReadyHandler();
                        document.getElementById('iframe').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: gameData
                        }), '*');
                        return console.warn('***** onGameReadyHandler');
                    }
                    case 'onGameEndHandler': {
                        if (this.props.onGameEndHandler)
                            await this.props.onGameEndHandler();
                        this.setState({ gameCompleted: true });
                        return console.warn('***** onGameEndHandler');
                    }
                    case 'onGameExitHandler': {
                        if (this.props.onGameExitHandler)
                            await this.props.onGameExitHandler();
                        return console.warn('***** onGameExitHandler');
                    }
                    case 'onGameCloseHandler': {
                        if (this.props.onGameCloseHandler)
                            await this.props.onGameCloseHandler();
                        return console.warn('***** onGameCloseHandler');
                    }
                    case 'onGameErrorHandler': {
                        if (this.props.onGameErrorHandler)
                            this.props.onGameErrorHandler(data.data);
                        return console.warn('***** onGameErrorHandler ', data.data);
                    }
                    default:
                        return;
                }
            }
            catch (_a) { }
        };
        this.hideSpinner = () => {
            this.setState({
                loading: false
            });
        };
        this.renderIframe = () => {
            const { classes } = this.props;
            const { isPortrait } = this.state;
            if (isPortrait) {
                return ((0, jsx_runtime_1.jsx)("iframe", { src: this.props.gameUrl, id: 'iframe', className: classes.iframe, onLoad: this.hideSpinner, allow: "autoplay", scrolling: "no", allowFullScreen: true }));
            }
            return ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.interactiveGame.onlyPortraitMode') })));
        };
        this.renderLoadAgain = () => (0, jsx_runtime_1.jsx)(LoadError_1.default, { onReloadIconPress: this.props.getGameData, text: 'Error loading a game. Please try again.' });
        this.state = Object.assign({}, INITIAL_STATE);
    }
    componentDidMount() {
        this.setState({ loading: true }, () => {
            this.orientationChange();
        });
        this.registerGame(this.props.vendor);
    }
    componentWillReceiveProps(nextProps) {
        this.unRegisterGame(this.props.vendor);
        this.registerGame(nextProps.vendor);
    }
    componentWillUnmount() {
        this.unRegisterGame(this.props.vendor);
        window.removeEventListener('orientationchange', this.orientationChange);
    }
    render() {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(InformationDialog_1.default, Object.assign({ open: this.props.visible, hideXButton: true, hideButton: true, onClose: this.onCloseGame, maxWidth: 'lg', noSpaces: true, gameView: true, portraitMode: this.props.portraitMode, disableBackdropClick: true, reducedWidth: true }, { children: [this.state.loading ? (0, jsx_runtime_1.jsx)(AppSpinner_1.default, { label: 'Loading Game...' }) : null, !this.props.gamePoints && !this.props.gameEntries ? this.renderLoadAgain() : this.renderIframe()] })) }));
    }
}
exports.default = (0, withTheme_1.default)((0, withStyles_1.default)(InteractiveGameStyle_1.default)((0, react_i18next_1.withTranslation)()(DigitalRevealGame)));
//# sourceMappingURL=DigitalRevealGame.js.map